export default "__VITE_ASSET__fee8b598__"